import { SvgBase } from "../svg.base";

export const ProfileOutline = () => (
  <SvgBase
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#888"
      d="M12,12.125 C9.1699531,12.125 6.875,9.8300469 6.875,7 C6.875,4.1699531 9.1699531,1.875 12,1.875 C14.8300469,1.875 17.125,4.1699531 17.125,7 C17.125,9.8300469 14.8300469,12.125 12,12.125 Z M12,10.625 C14.0016198,10.625 15.625,9.00161977 15.625,7 C15.625,4.99838023 14.0016198,3.375 12,3.375 C9.99838023,3.375 8.375,4.99838023 8.375,7 C8.375,9.00161977 9.99838023,10.625 12,10.625 Z M4.625,21.375 C4.625,21.7892136 4.28921356,22.125 3.875,22.125 C3.46078644,22.125 3.125,21.7892136 3.125,21.375 C3.125,16.4732864 7.09828644,12.5 12,12.5 C16.9017136,12.5 20.875,16.4732864 20.875,21.375 C20.875,21.7892136 20.5392136,22.125 20.125,22.125 C19.7107864,22.125 19.375,21.7892136 19.375,21.375 C19.375,17.3017136 16.0732864,14 12,14 C7.92671356,14 4.625,17.3017136 4.625,21.375 Z"
    />
  </SvgBase>
);



